import { render, staticRenderFns } from "./LockedHeader.vue?vue&type=template&id=718508d1&scoped=true&lang=pug"
import script from "./LockedHeader.vue?vue&type=script&lang=ts"
export * from "./LockedHeader.vue?vue&type=script&lang=ts"
import style0 from "./LockedHeader.vue?vue&type=style&index=0&id=718508d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718508d1",
  null
  
)

export default component.exports